const { REACT_APP_BACKEND_URL } = process.env;

// Fallback to local backend when the env var is not set (useful for local dev)
const BACKEND_URL = REACT_APP_BACKEND_URL || 'http://localhost:5000';

const url = {
    login                       : `${BACKEND_URL}/login/`,
    keyCheck                    : `${BACKEND_URL}/checkKey/`,
    sendPin                     : `${BACKEND_URL}/sendAuthPin/`,
    optCheck                    : `${BACKEND_URL}/checkAuthPin/`,
    sendEmail                   : `${BACKEND_URL}/sendEmail/`,
    sendEmailPdf                : `${BACKEND_URL}/sendEmail/pdf`,
    adminEmailNotification      : `${BACKEND_URL}/adminEmailNotification/`,
    oneLicence                  : `${BACKEND_URL}/oneLicence/`,
    allUsers                    : `${BACKEND_URL}/allUsers/`,
    addUser                     : `${BACKEND_URL}/addUser/`,
    importUsersCSV              : `${BACKEND_URL}/importUsersCSV/`,
    updateUser                  : `${BACKEND_URL}/updateUser/`,
    deleteUser                  : `${BACKEND_URL}/deleteUser/`,
    getAnswers                  : `${BACKEND_URL}/getAnswers/`,
    getResults                  : `${BACKEND_URL}/getResults/`,
    survey                      : `${BACKEND_URL}/survey/`,
    saveResults                 : `${BACKEND_URL}/saveResults/`,
    getCompanies                : `${BACKEND_URL}/getCompanies/`,
    addCompany                  : `${BACKEND_URL}/addCompany/`,
    editCompany                 : `${BACKEND_URL}/editCompany/`,
    translationChanges          : `${BACKEND_URL}/api/translation-changes`,
    storePdfOnServer            : `${BACKEND_URL}/storePdf/`,
    checkPdfExists              : `${BACKEND_URL}/checkPdfExists/`,
    downloadPdf                 : `${BACKEND_URL}/downloadPdf/`,
    // Email Analytics
    getUserAnalytics            : `${BACKEND_URL}/analytics/user/`,
    getAnalyticsSummary         : `${BACKEND_URL}/analytics/summary`,
    // Frontend Logging
    logFrontend                 : `${BACKEND_URL}/log/frontend`,
    logFrontendBatch            : `${BACKEND_URL}/log/frontend/batch`,
}

// Provide a simple base URL for endpoints or admin UI that expect `url.base`
url.base = BACKEND_URL;

export default url